import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Abdurazzoq Nurullaev </span>
            from <span className="purple"> Tashkent, Uzbekistan.</span>
            <br />
            I'm currently learning JS___________________React at Mars Space IT
            <br>

            </br>
            <br />
            I'm 14 years old and I'm  a Frontend Developer 
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Write Code 
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Abdurazzoq</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
